import { Component } from '@angular/core';

@Component({
  selector: 'icon-download',
  templateUrl: './icon-download.component.html',
  styleUrls: ['./icon-download.component.scss']
})
export class IconDownloadComponent {}
